const itln = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export default function money(value: number) {
  return itln.format(value);
}
